import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/es/storage";

interface NavigationSelectionState {
  activeSection: string | null;
  expandedSection: string | null;
}

const initialState: NavigationSelectionState = {
  activeSection: null,
  expandedSection: null,
};

const { actions, reducer: navigationSelectionReducer } = createSlice({
  name: "navigationSelection",
  initialState,
  reducers: {
    setActiveSection: (state, action: PayloadAction<string | null>) => {
      state.activeSection = action.payload;
    },
    setExpandedSection: (state, action: PayloadAction<string | null>) => {
      state.expandedSection = action.payload;
    },
  },
});

export const { setActiveSection, setExpandedSection } = actions;

// Redux-persist configuration for mobile navigation state
// Persists mobile navigation preferences (active section, expanded section) to localStorage
const navigationSelectionPersistConfig = {
  key: "navigationSelection",
  storage: storage, // localStorage for cross-session persistence
  stateReconciler: autoMergeLevel2,
};

export default persistReducer<NavigationSelectionState>(navigationSelectionPersistConfig, navigationSelectionReducer);
